/** We want literal %20 in files to work, so we use + for spaces. */
export const normalizeFilenameForView = (name: string | undefined): string => {
  return name ? name.replaceAll(' ', '+') : '';
};

/**
 * `directory` is URL-decoded by the backend, so it must be percent-encoded —
 * otherwise an `&` in a name (e.g. `styles&scripts`) splits the query string and
 * the backend gets a truncated directory, returning 404. `filename` is read from
 * the raw query string (`+` decodes to space), so it keeps the + normalization.
 */
export const buildViewFileUrl = (siteId: string, filename?: string, directory?: string): string => {
  let url = `sites/${siteId}/files/view?filename=${normalizeFilenameForView(filename)}`;

  if (directory) {
    url += `&directory=${encodeURIComponent(directory)}`;
  }

  return url;
};

/** Both params are URL-decoded by the backend, so percent-encode them to survive `&` etc. */
export const buildDownloadFileUrl = (
  siteId: string,
  filename: string,
  directory: string
): string => {
  return `sites/${siteId}/files/download?filename=${encodeURIComponent(filename)}&directory=${encodeURIComponent(directory)}`;
};
